<div class="card" *ngIf="field?.fieldGroup?.length">
  <h3 class="card-header">{{ props?.label }}</h3>
  <div class="card-error">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <div class="card-body">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
